import {api, ApiResponse} from "./api";

export interface Utilisateur {
	id: number;
	email: string;
	prenom: string;
	nom: string;
	adresse: string;
	nom_complet: string;
	telephone: string;
	est_referent: boolean;
	user_group: {
		id: number;
		groupe: string;
	} | null;
	groupe_name: string;
}

export interface Groupes {
	id: number;
	groupe: string;
}

export interface ProfilRequest {
  nom: string;
  prenom: string;
  telephone: string;
  email: string;
  group_id: number| null;
}

export interface GroupesWithReferents {
	id: number;
	groupe: string;
	referents: Referents[];
	adresse_par_defaut: string;
}

export interface Referents {
	id: number;
	nom_complet: string;
}

export const getUtilisateurs = async (): Promise<Utilisateur[]> => {
	try {
		const response = await api.get<ApiResponse<Utilisateur[]>>('/utilisateurs');
		return response.data.data.map((utilisateur) => ({
			...utilisateur,
			groupe_name: utilisateur.user_group?.groupe ?? "",
		}));
	} catch (error) {
		console.error('Erreur lors de la récupération des livraisons:', error);
		throw error;
	}
};

export const getGroupes = async (): Promise<Groupes[]> => {
	try {
		const response = await api.get<ApiResponse<Groupes[]>>('/groupes');
		return response.data.data;
	} catch (error) {
		console.error('Erreur lors de la récupération des groupes');
		throw error;
	}
}

export const getGroupesWithReferents = async (): Promise<GroupesWithReferents[]> => {
	try {
		const response = await api.get<ApiResponse<GroupesWithReferents[]>>('/groupes_referents');
		return response.data.data;
	} catch (error) {
		console.error('Erreur lors de la récupération des groupes avec référents');
		throw error;
	}
}

export const updateUtilisateur = async (id: number, utilisateur: ProfilRequest): Promise<ApiResponse<Utilisateur>> => {
	try {
		const response = await api.put<ApiResponse<Utilisateur>>(`/utilisateurs/${id}`, utilisateur);
		return response.data;
	} catch (error) {
		console.error('Erreur lors de la mise à jour de l\'utilisateur');
		throw error;
	}
}

export const updateUtilisateurReferent = async (id: number, est_referent: boolean): Promise<ApiResponse<Utilisateur>> => {
	try {
		const response = await api.put<ApiResponse<Utilisateur>>(`/utilisateurs/${id}`, {est_referent});
		return response.data;
	} catch (error) {
		console.error('Erreur lors de la mise à jour de l\'utilisateur');
		throw error;
	}
}

export const deleteUtilisateur = async (): Promise<boolean> => {
	try {
		const response = await api.delete<ApiResponse<string>>(`/utilisateurs`);
		return response.data.status === 'success';
	} catch (error) {
		console.error('Erreur lors de la suppression de l\'utilisateur');
		throw error;
	}
}

export interface PasswordChangeRequest {
	current_password: string;
	password: string;
	password_confirmation: string;
}

export const updatePassword = async (data: PasswordChangeRequest): Promise<ApiResponse<{ message: string }>> => {
	try {
		const response = await api.post<ApiResponse<{ message: string }>>('/utilisateurs/new_password', data);
		return response.data;
	} catch (error) {
		console.error('Erreur lors de la mise à jour du mot de passe');
		throw error;
	}
}